// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmailSent_wrapper__-2oas","title":"EmailSent_title__DvQPL","emailSentSubTitle":"EmailSent_emailSentSubTitle__3QMrU","backBtn":"EmailSent_backBtn__1y7hM"};